"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var QueryableString = function () {
  function QueryableString(str) {
    this.str = str;
  }
  QueryableString.prototype.startsWith = function (searchString) {
    return this.str.indexOf(searchString) === 0;
  };
  QueryableString.prototype.endsWith = function (searchString) {
    var reverseString = "";
    var reverseSearchString = searchString.split("").reverse().join("");
    reverseString = this.str.split("").reverse().join("");
    return this.startsWith.call({
      str: reverseString
    }, reverseSearchString);
  };
  QueryableString.prototype.contains = function (searchString) {
    return this.str.indexOf(searchString) !== -1;
  };
  QueryableString.prototype.equals = function (compareString) {
    return this.str === compareString;
  };
  QueryableString.prototype.value = function () {
    return this.str;
  };
  return QueryableString;
}();
exports.QueryableString = QueryableString;